import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, retry, switchMap } from 'rxjs/operators';
import { SubmissionsFacade } from '../../../../../../domain/+state/submissions.facade';
import { DeleteRequirementDocumentData, SaveRequirementDocumentData } from '../../../../../../domain/models/submissions.model';
import { FormDetailsAdapter } from '../../form-details.data';
import { RequirementData } from '../../../../shared/components/requirement-documents-section/requirement-documents-panel.model';
import { ApplicationData } from '../../../../../../domain/models/application.model';

@Injectable({
  providedIn: 'root'
})
export class AutosaveDocumentsStepService {
  constructor(
    private readonly submissionsFacade: SubmissionsFacade,
    private readonly adapter: FormDetailsAdapter,
  ) { }

  saveDocuments(applicationId: number, documentsToSave: SaveRequirementDocumentData[], application: ApplicationData): Observable<RequirementData[]> {
    const requirementIds = documentsToSave.map(doc => doc.requirementId);
    return this.submissionsFacade.saveApplicationDocuments(applicationId, documentsToSave, true)
      .pipe(
        retry(3),
        switchMap(() => this.refreshRequirementsData(applicationId, requirementIds, application))
      )
  }

  deleteDocument(applicationId: number, data: DeleteRequirementDocumentData, application: ApplicationData): Observable<RequirementData> {
    return this.submissionsFacade.deleteApplicationDocument(applicationId, data.documentId, true)
      .pipe(
        retry(3),
        switchMap(() => this.refreshRequirementData(applicationId, data.requirementId, application))
      )
  }

  private refreshRequirementData(applicationId: number, requirementId: number, application: ApplicationData): Observable<RequirementData> {
    return this.refreshRequirementsData(applicationId, [requirementId], application).pipe(
      map((requirements: RequirementData[]) => requirements?.[0])
    );
  }

  private refreshRequirementsData(applicationId: number, requirementIds: number[], application: ApplicationData): Observable<RequirementData[]> {
    return this.submissionsFacade.getApplicationDocuments(applicationId)
      .pipe(map((documents) =>
        this.adapter.adaptDocumentsSectionData(documents, application).requirements.filter(req => requirementIds.includes(req.requirementId)))
      );
  }
}
